module.exports = __webpack_public_path__ + "static/img/sky.da19153.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sky.png
// module id = 292
// module chunks = 34